module.exports = __webpack_public_path__ + "img/img-header-2.907e5798.png";